import { render, staticRenderFns } from "./xw-drawer.vue?vue&type=template&id=53627790&scoped=true"
import script from "./xw-drawer.vue?vue&type=script&lang=js"
export * from "./xw-drawer.vue?vue&type=script&lang=js"
import "./xw-drawer.vue?vue&type=style&index=0&id=53627790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53627790",
  null
  
)

export default component.exports